import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';

const CHUNK_RELOAD_GUARD_KEY = 'epg_chunk_reload_attempted_for_version';

export class GlobalErrorHandler extends BugsnagErrorHandler {
    handleError(error: unknown): void {
        if (GlobalErrorHandler.reloadForChunkLoadError(error)) {
            return;
        }

        super.handleError(error);
    }

    static reloadForChunkLoadError(error: unknown): boolean {
        if (!GlobalErrorHandler.isChunkLoadError(error)) {
            return false;
        }

        const currentVersion = GlobalErrorHandler.getLoadedBundleSignature();
        if (sessionStorage.getItem(CHUNK_RELOAD_GUARD_KEY) === currentVersion) {
            return false;
        }

        sessionStorage.setItem(CHUNK_RELOAD_GUARD_KEY, currentVersion);
        GlobalErrorHandler.reloadPage();
        return true;
    }

    static clearChunkReloadGuard(): void {
        sessionStorage.removeItem(CHUNK_RELOAD_GUARD_KEY);
    }

    static isChunkLoadError(error: unknown): boolean {
        const value = GlobalErrorHandler.getErrorText(error);
        return /ChunkLoadError|Loading chunk [\d]+ failed|Loading CSS chunk [\d]+ failed|Failed to fetch dynamically imported module|importing a module script failed/i.test(value);
    }

    static reloadPage(): void {
        window.location.reload();
    }

    private static getLoadedBundleSignature(): string {
        const scripts = Array.from(document.scripts)
            .map(script => {
                const url = new URL(script.src, window.location.origin);
                const segments = url.pathname.split('/');
                return segments[segments.length - 1];
            })
            .filter(src => /\.[a-z0-9]{8,}\.js$/i.test(src))
            .sort();

        return scripts.length ? scripts.join('|') : 'unknown';
    }

    private static getErrorText(error: unknown): string {
        if (!error) {
            return '';
        }

        if (typeof error === 'string') {
            return error;
        }

        const wrappedError = error as { message?: string; name?: string; error?: unknown; rejection?: unknown };
        return [
            wrappedError.name,
            wrappedError.message,
            GlobalErrorHandler.getErrorText(wrappedError.error),
            GlobalErrorHandler.getErrorText(wrappedError.rejection),
        ].filter(Boolean).join(' ');
    }
}
